import React from "react";

// Keuze bij een gewijzigde partnerprijs: geldt de nieuwe prijs ook voor
// aanvragen die nog open staan, of alleen voor nieuwe aanvragen vanaf nu?
// Waarden komen overeen met `priceScope` op de server.
export const PRICE_SCOPE_OPEN = "open";
export const PRICE_SCOPE_NEW = "new";

const OPTIONS = [
  {
    value: PRICE_SCOPE_OPEN,
    label: "Alle openstaande aanvragen",
    hint: "Ook aanvragen die nog niet op een factuur staan krijgen de nieuwe prijs.",
  },
  {
    value: PRICE_SCOPE_NEW,
    label: "Alleen nieuwe aanvragen, vanaf nu",
    hint: "Aanvragen die er al liggen houden de oude prijs.",
  },
];

const PriceScopeChoice = ({ value, onChange, disabled }) => (
  <div className="rounded-xl bg-amber-50 p-4 ring-1 ring-amber-200">
    <p className="text-sm font-medium text-gray-900">
      De prijs is gewijzigd. Voor welke aanvragen geldt de nieuwe prijs?
    </p>
    <div className="mt-2 space-y-2">
      {OPTIONS.map((o) => (
        <label key={o.value} className="flex items-start gap-2 text-sm">
          <input
            type="radio"
            name="price-scope"
            checked={value === o.value}
            onChange={() => onChange(o.value)}
            disabled={disabled}
            className="mt-1 h-4 w-4 border-gray-300"
          />
          <span>
            <span className="font-medium text-gray-900">{o.label}</span>
            <span className="block text-xs text-gray-600">{o.hint}</span>
          </span>
        </label>
      ))}
    </div>
    <p className="mt-2 text-xs text-gray-600">
      Bestaande facturen veranderen niet, ook concepten niet.
    </p>
  </div>
);

export default PriceScopeChoice;
